import { render } from "./SummaryList.vue?vue&type=template&id=06418a65&ts=true&lang=pug"
import script from "./SummaryList.vue?vue&type=script&lang=ts"
export * from "./SummaryList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__